import { Dispatch, Action } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { AuthState } from './auth/types';
import { AuthSaga } from './auth/sagas';

import { SignupState } from './signup/types';
import { SignupSaga } from './signup/sagas';

import { UserManagementState } from './user-management/types';
import { UserManagementSaga } from './user-management/sagas';

import { LPState } from './lps/types';
import { LPSaga } from './lps/sagas';

import { DocusignState } from './docusign/types';
import { DocusignSaga } from './docusign/sagas';

import { LPOfferingSaga } from './offerings/sagas';
import { OfferingState } from './offerings/types';

import { InterestState } from './interests/types';
import { InterestSaga } from './interests/sagas';

import { DownloadsSaga } from './downloads/sagas';
import { DownloadsState } from './downloads/types';

import { ConfigSaga } from './config/saga';
import { ConfigState } from './config/types';

export interface ApplicationState {
  auth: AuthState;
  signup: SignupState;
  docusign: DocusignState;
  userManagement: UserManagementState;
  lp: LPState;
  offering: OfferingState;
  interest: InterestState;
  downloads: DownloadsState;
  config: ConfigState;
}

export interface ConnectedReduxProps<A extends Action = Action> {
  dispatch: Dispatch<A>;
}

export function* RootSaga() {
  yield all([
    fork(AuthSaga),
    fork(SignupSaga),
    fork(DocusignSaga),
    fork(UserManagementSaga),
    fork(LPSaga),
    fork(LPOfferingSaga),
    fork(InterestSaga),
    fork(DownloadsSaga),
    fork(ConfigSaga)
  ]);
}
